import { render, staticRenderFns } from "./CompanionArticle.vue?vue&type=template&id=66011ea6&scoped=true&lang=pug&"
import script from "./CompanionArticle.vue?vue&type=script&lang=js&"
export * from "./CompanionArticle.vue?vue&type=script&lang=js&"
import style0 from "./CompanionArticle.vue?vue&type=style&index=0&id=66011ea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66011ea6",
  null
  
)

export default component.exports